import fetch from '../config/api'
/**
 * 问卷调查列表
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {question_id} 问卷id
 */
const QuestionList = (language, question_id = '') => fetch('/question/get_question', {
  p: 'wx',
  language,
  question_id
});
/**
 * 问卷调查列表提交
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {ques_id} 问卷id
 */
const QuestionSubmit = (language, data, num, ques_id = '') => fetch('/question/postquesinfo_new', {
  p: 'wx',
  language,
  data,
  ques_id,
  num
}, 'POST');



export default {
  QuestionList,
  QuestionSubmit
}
